import { Box, Typography, Popover, CircularProgress } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import useCaptcha from "hooks/useCaptcha";

const sx = {
  captchaBox: {
    display: "flex",
    height: "60px",
    width: "200px",
    backgroundColor: (theme) => theme.palette.common.white,
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd"
  }
};

export default function CaptchaBox({ onLoad, onSuccess } = {}) {
  const {
    showCaptcha,
    isCaptchaLoading,
    isCaptchaSuccess,
    anchorEl,
    captchaBoxRef,
    handleCaptchaClick,
    handleCaptchaClose
  } = useCaptcha({ onLoad: onLoad, onSuccess: onSuccess });

  return (
    <Box ref={captchaBoxRef} sx={sx.captchaBox}>
      {isCaptchaLoading ? (
        <CircularProgress sx={{ marginRight: "8px" }} size={24} />
      ) : isCaptchaSuccess ? (
        <CheckIcon sx={{ color: "green" }} fontSize="large" />
      ) : (
        <Box
          sx={{ marginRight: "8px", width: 24, height: 24, border: "1px solid black", cursor: "pointer" }}
          onClick={handleCaptchaClick}
        />
      )}

      <Typography variant="body1">I'm not a robot</Typography>
      <Popover
        open={showCaptcha}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleCaptchaClose}
      >
        <Box
          p={3}
          width={340}
          height={500}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          position="relative"
        >
          <Box id="captchaForm" />
        </Box>
      </Popover>
    </Box>
  );
}
